import { Injectable } from '@angular/core';

import { ApiHttpClient } from '../../../infrastructure/infrastructure.module';

import { Observable } from 'rxjs';
import { api } from "@bayclubs/utils"
import { camps } from '../../models/models.generated';

@Injectable({providedIn: 'root'})
export class MembersApiService {

    constructor(private http: ApiHttpClient) { }

    public search(request: camps.MemberSearchRequest): Observable<api.OperationPagedResult<camps.MemberInfoModel>> {
        return this.http.post<api.OperationPagedResult<camps.MemberInfoModel>>("member/search", request, false);
    }

}
